import React,{useEffect,useState} from 'react';
import Button from 'react-bootstrap/Button';
import * as Yup from 'yup';
import {InputText,Form,SelectField} from '../../components/FormElement'

import { fetchWrapper } from '../helpers';
import { useToast } from '@chakra-ui/react'



function Edit({loadList,handleClose,rs}){
	const toast = useToast()


	const backendUrl = process.env.REACT_APP_API_URL

	const [formData, setFormData] = useState({
    story_id: rs.story_id,
    type_id: rs.type_id,
    id:rs.id
  
    
    
  });

  const FormSchema = Yup.object().shape({
	     story_id: Yup.string()
	          .required('Required'),
	    type_id: Yup.string()
	          .required('Required'),	   
	    
	     
	});


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		   let  data = values
		  
	       
	     const url = `${backendUrl}/api/broad_cast`;
  		 await fetchWrapper.post(url,data)
  		 loadList();

  		 toast({
  		 	  position: 'top',
  		 	  variant:'top-accent',
          title: 'Congratulation.',
          description: "Record has been updated.",
          status: 'info',
          duration: 1000,
          isClosable: true,
        })
  		 handleClose();
	}

	


	return (

			<>
			<div className="create_user_form">
				<Form
			            enableReinitialize
			            validationSchema={FormSchema}
			            initialValues={formData}
			            onSubmit={onSubmit}
			 	>


			 	<SelectField name="story_id" title="Story"  />

			 	<SelectField name="type_id" title="Broadcast via"  />

			 	
			 	


		         <Button
				            mt={4}
				            colorScheme='teal'
				            className="primary"
				            type='submit'
		          		>
		           		 Save
		          		</Button>

			</Form>
			</div>
			</>

	)
}

export default Edit;